const ICONS: Record<string, { style: string; letter: string }> = {
  buylist: { style: 'bg-blue-500/20 text-blue-400', letter: 'B' },
  selllist: { style: 'bg-orange-500/20 text-orange-400', letter: 'S' },
  deck: { style: 'bg-purple-500/20 text-purple-400', letter: 'D' },
  alert: { style: 'bg-yellow-500/20 text-yellow-400', letter: '!' },
}

const FALLBACK = { style: 'bg-gray-500/20 text-muted', letter: '?' }

/** Badge colour classes + letter for a notification's icon kind. */
export function notificationIcon(icon: string) {
  return ICONS[icon] ?? FALLBACK
}
